import React from 'react';
import { CustomerInfoCard } from './CustomerInfoCard';
import Grid from '@mui/material/Grid2';
import { getCustomerInfoCardsConfiguration } from 'modules/customers/lib';
import { CustomerDetails } from '@trnsact/trnsact-shared-types';

interface Props {
  customerDetails: CustomerDetails;
}

export const CustomerInfoCards = ({ customerDetails }: Props) => {
  const cardsConfiguration = getCustomerInfoCardsConfiguration(customerDetails);

  return (
    <Grid container spacing={1}>
      {cardsConfiguration.map(cardConfig => (
        <Grid size={{ xs: 6, md: 3, lg: 2 }} key={cardConfig.title}>
          <CustomerInfoCard cardConfig={cardConfig} />
        </Grid>
      ))}
    </Grid>
  );
};
